import { Event, EventHint } from '@sentry/types';
import { DISCARD_SENTRY_ERRORS } from './constants';

export const isTranslationRelated = (error: Error): boolean => {
  const { message } = error;
  if (!message) return false;

  // "'removeChild' on 'Node'" is likely caused by google translate
  // discard the error since it's creating too much noise and using up sentry quota
  // https://stackoverflow.com/questions/54880669/react-domexception-failed-to-execute-removechild-on-node-the-node-to-be-re
  // https://lifesaver.codes/answer/make-react-resilient-to-dom-mutations-from-google-translate
  const reRemoveChild = new RegExp(
    "Failed to execute 'removeChild' on 'Node'",
    'i'
  );

  return reRemoveChild.test(message);
};

export const shouldLogEvent = (error: Error): boolean => {
  const { message } = error;
  if (!message) return true;

  const matchErrors = DISCARD_SENTRY_ERRORS.some((error) => {
    const re = new RegExp(error, 'i');
    return re.test(message);
  });

  return !(matchErrors || isTranslationRelated(error));
};

export const beforeSend = (event: Event, hint: EventHint): Event | null => {
  // filter out the errors we want to ignore
  const error = hint?.originalException;
  if (error && typeof error !== 'string' && !shouldLogEvent(error)) {
    return null;
  }

  return event;
};
